
import Vue from 'vue';
import * as TagsetStore from '@/store/search/tagset';
import * as CorpusStore from '@/store/search/corpus';

import { Tagset } from '@/types/apptypes';
import { escapeRegex } from '@/utils';

import Modal from '@/components/Modal.vue';

export default Vue.extend({
	components: {
		Modal,
	},
	props: {
		annotation: Object as () => CorpusStore.NormalizedAnnotation,
		open: { default: true }
	},
	data: () => ({
		annotationValue: null as null|Tagset['values'][string],
		selected: {} as {[key: string]: boolean}
	}),
	computed: {
		allAnnotations: CorpusStore.get.allAnnotationsMap,
		tagset: TagsetStore.getState,
		isValidTagset(): boolean { return TagsetStore.getState().state === 'loaded'; },
		errorMessage(): string { return this.isValidTagset ? '' : TagsetStore.getState().message; },
		query(): string {
			if (this.annotationValue == null) { return ''; }

			return [
				`${this.annotation.id}="${escapeRegex(this.annotationValue.value)}"`,
				...this.annotationValue.subAnnotationIds.map(subAnnot => {
					const {values} = this.tagset.subAnnotations[subAnnot];
					const selected = values.filter(v => this.selected[`${this.annotationValue!.value}/${subAnnot}/${v.value}`]);

					return {subAnnot, escapedValues: selected.map(v => escapeRegex(v.value))};
				})
				.filter(({escapedValues}) => escapedValues.length > 0)
				.map(({subAnnot, escapedValues}) => `${subAnnot}="${escapedValues.join('|')}"`)
			].join('&');
		},
	},
	methods: {
		reset() {
			Object.keys(this.selected).forEach(k => this.selected[k] = false);
			this.annotationValue = null;
		},
		submit() {
			this.$emit('submit', this.query);
		}
	},
	created() {
		Object.values(this.tagset.values).forEach(value => {
			value.subAnnotationIds.forEach(annotId => {
				const {values, id} = this.tagset.subAnnotations[annotId];
				values.forEach(({value: subAnnotValue}) => {
					Vue.set(this.selected, `${value.value}/${annotId}/${subAnnotValue}`, false);
				});
			});
		});
	}
});
